export const MACDILL = 'macdill';
export const TRAVIS = 'travis';
export const JBSA_PROVIDERS = 'jbsa-providers';
export const EVERETT = 'everett';
export const DEMO = 'demo';
export const TRAVIS_AMDS_349 = '349amds';
